import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SessionService } from '../session.service';

@Component({
  selector: 'app-theme-switcher',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './theme-switcher.component.html',
  styleUrl: './theme-switcher.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThemeSwitcherComponent {
  protected readonly session = inject(SessionService);
  protected readonly isDarkTheme = computed(() => this.session.currentTheme() === 'dark');

  protected toggleTheme(): void {
    this.session.toggleTheme();
  }
}
